module.exports = __webpack_public_path__ + "airbnb-fav-icon.png?9f5298c9f929519b2fdc0ffda28cd9ab";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/airbnb-fav-icon.png
// module id = 486
// module chunks = 0